import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ScheduleProgrammingService } from './../services/schedule.service';
import { ProgrammingUtilsService } from './../../../common/services/utils.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';

@Component({
  selector: 'prg-start-time',
  templateUrl: './start-time.component.html',
  styleUrls: ['./start-time.component.less']
})
export class StartTimeComponent extends BaseRoutingComponent implements OnInit {
  startTime: Observable<any>;
  sunriseSunsetOffsetType: Observable<number>;
  sunriseOrSunset: Observable<number>;
  sunriseSunsetOffsetInterval: Observable<number>;
  isFixedTime: Observable<boolean>;

  sunriseSunsetOffset: number;

  constructor(
    protected router: Router,
    protected store: Store<any>,
    private route: ActivatedRoute,
    private utils: ProgrammingUtilsService,
    protected schedule: ScheduleProgrammingService
  ) {
    super();

    this.startTime = this.store.select(s => s.scheduleProgramming.startTime);
    this.sunriseSunsetOffsetInterval = this.store.select(s => s.scheduleProgramming.sunriseSunsetOffsetInterval);
    this.sunriseOrSunset = this.store.select(s => s.scheduleProgramming.sunriseOrSunset);
    this.sunriseSunsetOffsetType = this.store.select(s => s.scheduleProgramming.sunriseSunsetOffsetType);
    this.isFixedTime = this.store.select(s => s.scheduleProgramming.isFixedTime);
    this.sunriseSunsetOffset = -1; // at sunset
  }

  ngOnInit() {
  }

  private setIsFixedTime(event: any) {
    this.schedule.setIsFixedStartTime((event.target.value === 'fixed'));
  }

  private setStartTime(event: any) {
    this.schedule.setStartTime(event.target.value);
  }

  setSunriseSunsetOffset(event: any) {
    switch (event.target.value) {
      case '-1': // sunrise
        this.schedule.setSunriseSunsetRelativeTo(1);
        this.schedule.setSunriseSunsetOffsetType(0);
        break;
      case '1': // before sunrise
        this.schedule.setSunriseSunsetRelativeTo(1);
        this.schedule.setSunriseSunsetOffsetType(1);
        break;
      case '2': // after sunrise
        this.schedule.setSunriseSunsetRelativeTo(1);
        this.schedule.setSunriseSunsetOffsetType(2);
        break;
      case '-2': // sunset
        this.schedule.setSunriseSunsetRelativeTo(2);
        this.schedule.setSunriseSunsetOffsetType(0);
        break;
      case '3': // before sunset
        this.schedule.setSunriseSunsetRelativeTo(2);
        this.schedule.setSunriseSunsetOffsetType(1);
        break;
      case '4': // after sunset
        this.schedule.setSunriseSunsetRelativeTo(2);
        this.schedule.setSunriseSunsetOffsetType(2);
        break;
    }

    this.schedule.setSunriseSunsetOffsetInterval(15);
  }

  private setSunriseSunsetOffsetInterval(event: any) {
    this.schedule.setSunriseSunsetOffsetInterval(event.target.value);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/start-time/start-time.component.ts